<template>
	<div class="policyAdmin">
		<subsidyDetail v-if="detailShow" :visible.sync="detailShow" :batchId="batchId"></subsidyDetail>
		<div class="policyAdminCon" v-show="!detailShow">
			<div class="head">
				<div class="left">
					<div class="title">
						补贴提报记录
					</div>
				</div>
				<el-button size="medium" type="primary" @click="openAdd()">提报补贴</el-button>
			</div>
			
			<div v-loading="loading" class="ul">
				<el-table :data="list" border :header-cell-style="{ background: '#51A190', color: '#FFF',borderColor:'#51A190' }">
					<el-table-column label="政策名称" prop="policy.title" align="center"/>
					<el-table-column label="提报总金额" width="220" prop="total_amount" align="center"/>
					<el-table-column label="提报人" width="120" prop="user.en_user_name" align="center"/>
					<el-table-column label="提报时间" width="180" prop="created_at" align="center"/>
					<el-table-column label="操作" align="center" width="180">
						<template slot-scope="scope">
							<el-button type="text" @click="openDetail(scope.row.id)">查看明细</el-button>
							<el-button type="text" style="color: #F44;" @click="revoke(scope.row.id)">撤销提报</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div v-if="total>limit" class="page">
					<el-pagination background :page-size="limit" layout="prev, pager, next" :total="total"
						@current-change='changePage'>
					</el-pagination>
				</div>
			</div>
		</div>
		
		<el-dialog title="提报政策补贴" :visible.sync="addShow" width="600px" :close-on-click-modal="false" :close-on-press-escape="false">
			<div v-loading="addLoading">
				<el-form label-width="98px" :model="form" :rules="rules" ref="uploadform">
					<el-form-item label="提报政策："  style="margin-bottom: 8px;">
						<el-select v-model="form.policy_id" disabled filterable style="width: 100%;" placeholder="请选择提报补贴的政策">
						    <el-option v-for="item in policyList" :key="item.id" :label="item.title" :value="item.id" />
						</el-select>
					</el-form-item>
					<template v-if="form.policy_id">
						<el-form-item label="提报模板：" style="margin-bottom: 8px;">
							模板根据报名用户自动生成，
							<span style="color: #51A190;cursor: pointer;" @click="downloadTemplate()">点击下载提报模板</span>
						</el-form-item>
						<el-form-item label="上传文件：" prop="file">
							<div v-if="form.file" class="filebox" >
								<div><i class="el-icon-document"></i> {{form.file.name}}</div>
								<div class="reload" @click="handReload()">重新上传</div>
							</div>
							<div v-else class="uploadbox" @drop="handleDrop" @dragover="handleDragover" @dragenter="handleDragover" @click="$refs['upload-input'].click()">
								<input ref="upload-input" class="upload-input" type="file" accept=".xlsx, .xls" @change="handleClick">
								<i class="el-icon-upload uploadIcon"></i>
								<div>拖动文件至此处或<span style="color: #51A190;">点击上传</span></div>
							</div>
						</el-form-item>
					</template>
					
				</el-form>
				
				<div style="text-align: center;margin-top: 28px;" v-if="form.policy_id">
					<el-button size="medium" @click="addShow = false">取 消</el-button>
					<el-button size="medium" type="primary" @click="uploadFile()">确 定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import subsidyDetail from './components/subsidyDetail.vue'
	export default {
		name:'policySubsidy',
		components:{subsidyDetail},
		data() {
			var existFileRule = (rule, value, callback) => {
				if (!this.form.file) return callback(new Error('请上传提报文件'));
				callback();
			};
			return {
				newList:[],
				page: 1,
				total: 0,
				loading: false,
				list: [],
				limit: 10,
				addShow:false,
				addLoading:false,
				rules:{
					file: [{ required: true, validator: existFileRule, trigger: 'change' }],
				},
				form:{
					policy_id:'',
					file:null,
				},
				addLoading:false,
				batchId:'',
				policyList:[],
				detailShow:false,
				policy_id:'',
			}
		},
		created() {
			console.log(this.$route)
			if(this.$route.query.policy_id){
				this.policy_id = this.$route.query.policy_id
			}else{
				return this.$router.go(-1)
			}
			this.getList()
			this.getMypolicyList()
		},
		methods: {
			openDetail(id){
				this.batchId = id
				this.detailShow = true
			},
			downloadTemplate(){
				this.addLoading = true
				let data = {
					policy_id:this.form.policy_id,
					t:new Date().getTime()
				}
				this.$axios.get(`/api/client/ES/Policys/createPolicyExcel`,{params:data,responseType: 'blob'}).then(response => {
					if(response.type=='application/json'||response.type=='text/html'){
						const reader = new FileReader()
						reader.onload = ()=>{
							let msg = '下载模板失败';
							if(response.type == 'application/json') msg = JSON.parse(reader.result).msg;
							this.$eltips(msg,'error')
						}
						reader.readAsText(response)
						this.addLoading = false
						return
					}
					
					let blob = new Blob([response], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					if (window.navigator.msSaveOrOpenBlob) {
						//兼容ie
						window.navigator.msSaveBlob(blob, `补贴提报模板`);
					} else {
						let downloadElement = document.createElement('a');
						let href = window.URL.createObjectURL(blob); //创建下载的链接
						downloadElement.href = href;
						downloadElement.download = `补贴提报模板`; //下载后文件名
						document.body.appendChild(downloadElement);
						//此写法兼容火狐
						let evt = document.createEvent("MouseEvents");
						evt.initEvent("click", false, false);
						downloadElement.dispatchEvent(evt);
						document.body.removeChild(downloadElement);
					}
					this.addLoading = false
					this.$eltips('模板下载中','success')
				})
			},
			uploadFile(){
				this.$refs['uploadform'].validate((valid) => {
					if (!valid) return;
					let formData = new FormData();
					formData.append('file',this.form.file);
					formData.append('policy_id',this.form.policy_id);
					this.addLoading = true
					this.$axios.post('/api/client/ES/Policys/ImportPolicy',formData).then(res=>{
						this.addLoading = false
						if(res.code==200){
							this.$eltips(res.msg,'success')
							this.form.file = null
							this.addShow = false
							this.getList()
						}else{
							this.$eltips(res.msg,'error')
						}
					})
				});
			},
			handReload(){
				this.form.file = null
				this.$nextTick(()=>{
					this.$refs['upload-input'].click()
				})
			},
			handleClick(e){
				if(e.target.files.length==0) return this.$refs['upload-input'].value = null;
				const file = e.target.files[0]
				if(!this.isExcel(file)) return eltips('仅支持 .xlsx, .xls 文件','error');
				this.form.file = file
				this.$refs['upload-input'].value = null
				this.$refs['uploadform'].validateField('file')
			},
			handleDrop(e) {
				e.stopPropagation()
				e.preventDefault()
				if (this.loading) return
				const files = e.dataTransfer.files
				if (files.length !== 1) return eltips('请上传单个文件', 'error');
				const file = files[0]
				if(!this.isExcel(file)) return eltips('仅支持 .xlsx, .xls 文件','error');
				this.form.file = file
				this.$refs['upload-input'].value = null
				this.$refs['uploadform'].validateField('file')
			},
			handleDragover(e) {
			  e.stopPropagation()
			  e.preventDefault()
			  e.dataTransfer.dropEffect = 'copy'
			},
			isExcel(file) {
			  return /\.(xlsx|xls|csv)$/.test(file.name)
			},
			openAdd(){
				this.form.file = null
				this.form.policy_id = this.policy_id
				this.addShow = true
			},
			getMypolicyList(){
				let data = {
					audit_status:2,
					limit:9999,
					page:1
				}
				this.$axios.get('/api/client/ES/getMyPolicys',{params:data}).then(res=>{
					if(res.code==200){
						this.policyList = res.data.data
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			getList(){
				this.loading = true
				let data={
					page: this.page,
					limit: this.limit,
					policy_id:this.policy_id,
				}
				this.$axios.get('/api/client/ES/Policys/repartPolicyBatch', {params: data}).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.total = res.data.total
						this.list = res.data.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			changePage(e) {
				console.log(e, '---e')
				this.page = e
				this.getList()
			},
			// 停用和启用
			revoke(id){
				this.$confirm('此操作将撤销本次补贴提报，是否继续?', '撤销提报', {
					confirmButtonText: '确定撤销',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$axios.post('/api/client/ES/Policys/repartPolicyRevoke', { id: id, }).then(res => {
						if (res.code == 200) {
							this.loading = false
							this.$eltips(res.msg)
							this.getList()
						} else {
							this.loading = false
							this.$eltips(res.msg, 'error')
						}
					})
				}).catch(() => {});
			},
		}
	}
</script>

<style lang="scss" scoped>
	.policyAdmin{
		position: relative;
		padding: 24px 0;
		.policyAdminCon{
			width: 1200px;
			margin: 0 auto;
			position: relative;
			z-index: 2;
			.head{
				background-color: #FFF;
				margin-bottom: 16px;
				padding:18px 28px;
				border-radius: 16px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.title {
					color: #151515;
					font-size: 18px;
					font-weight: bold;
				}
			}
			
			.page {
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 18px 0 0;
			}
		
		    .ul{
				padding: 18px 28px;
				background: #FFFFFF;
				border-radius: 16px;
			}
		}
	
		.filebox{
			display: flex;
			align-items: center;
			justify-content: space-between;
			.reload{
				line-height: 1;
				color: #51A190;
				cursor: pointer;
			}
		}
		
		.uploadbox{
			width: 100%;
			height: 200px;
			border: 1px solid #DCDFE6;
			border-radius: 4px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			&:hover{
				border-color: #51A190;
				border-style: dashed;
			}
			.uploadIcon{
				font-size: 68px;
				color: #c0c4cc;
				line-height: 1;
				margin-bottom: 12px;
			}
			.upload-input{
			  display: none;
			  z-index: -9999;
			}
		}
	}
</style>